import { dialogs } from './registered-dialogs';
export const resetDialogs = () => {
    dialogs.clear();
};
